import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '..';
import { IconBase } from '../Base';
const Wrapper = styled.div `
  --home-scale: 1;
  --home-back-x: -6px;

  position: relative;
`;
const Back = styled.div `
  position: absolute;
  left: 0;
  top: 0;
  clip-path: polygon(9px 2px, 15px 8px, 15px 16px, 13px 18px, 20px 20px, 20px 0px, 9px 0px);

  svg {
    transform: translateX(var(--home-back-x));
  }
`;
const Home = styled.div `
  position: relative;
  z-index: 1;
  transform-origin: 0 50%;
  transform: scaleX(var(--home-scale));
`;
export const IconHome = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const wrapper = wrapperRef.current;
            if (!wrapper) {
                return;
            }
            gsap.to(wrapper, {
                keyframes: [
                    {
                        '--home-scale': 0.875,
                        duration: 0.2,
                    },
                    {
                        '--home-scale': 1,
                        delay: 0.15,
                        duration: 0.3,
                    },
                ],
            });
            gsap.to(wrapper, {
                keyframes: [
                    {
                        '--home-back-x': '0px',
                        duration: 0.25,
                    },
                    {
                        '--home-back-x': '-6px',
                        delay: 0.15,
                        duration: 0.3,
                        onComplete: triggerDone,
                    },
                ],
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Home, null,
            React.createElement(Icon.Home, null)),
        React.createElement(Back, null,
            React.createElement(IconBase, null,
                React.createElement("path", { d: "M8.75 2.5H13.3929C13.9402 2.5 14.4636 2.72433 14.8411 3.12069L19.25 7.75M19.25 7.75V14.5C19.25 16.1569 17.9069 17.5 16.25 17.5H12.75M19.25 7.75H14.75", fill: "none", strokeWidth: "1.5", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })))));
};
//# sourceMappingURL=Home.js.map